if (!customElements.get('upsell-add-to-cart-jl-jc')) {
  class UpsellAddToCartJlJc extends HTMLElement {
    constructor() {
      super();
      this.button = null;
      this.iconSpan = null;
      this.spinner = null;
      this.boundHandleClick = this.handleClick.bind(this);
    }

      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;

        this.iconSpan = this.button.querySelector('.cart-drawer-upsell-jl-jc__card-button-icon');
        this.textSpan = this.button.querySelector('.cart-drawer-upsell-jl-jc__card-button-text');
        this.spinner = this.button.querySelector('.loading__spinner');

        this.button.addEventListener('click', this.boundHandleClick);
      }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.boundHandleClick);
      }
    }

    handleClick(e) {
      e.preventDefault();

      if (this.button.disabled || this.button.classList.contains('loading')) {
        return;
      }

      const variantId = this.button.dataset.variantId;
      const quantity = parseInt(this.button.dataset.quantity) || 1;
      const discountCode = this.button.dataset.discountCode || '';
      const sellingPlanId = this.button.dataset.sellingPlanId || '';

      this.addToCart(variantId, quantity, discountCode, sellingPlanId);
    }

    async addToCart(variantId, quantity, discountCode, sellingPlanId) {
      try {
        this.setLoadingState(true);

        const cartData = this.buildCartData(variantId, quantity, discountCode, sellingPlanId);
        const response = await window.cartFetchWithRetry(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(cartData),
        });

        /*
         * Shopify answers a throttled request with an HTML body, so .json() would throw a
         * SyntaxError that hides the real cause. Throw here instead and let the catch below
         * surface the same "try again" message the shopper already gets for other failures.
         * 422 keeps its JSON error body and stays on the handleError(data) path untouched.
         */
        if (!response.ok && response.status !== 422) {
          throw new Error(`Cart add failed with status ${response.status}`);
        }

        const data = await response.json();

        if (data.status === 422 || data.status === 'error') {
          this.handleError(data);
        } else {
          await this.handleSuccess(variantId, data, discountCode);
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Error adding product to cart. Please try again.');
      } finally {
        this.setLoadingState(false);
      }
    }

    buildCartData(variantId, quantity, discountCode, sellingPlanId) {
      const cartDrawer = document.querySelector('cart-drawer');
      let sections = null;

      if (cartDrawer && cartDrawer.getSectionsToRender) {
        sections = cartDrawer
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',');
      }

      const cartData = {
        id: variantId,
        quantity: quantity,
        properties: {
          _upsell_jl_jc: 'true',
          _upsell_discount_code: discountCode || '',
        },
      };

      if (sellingPlanId && sellingPlanId.trim() !== '') {
        cartData.selling_plan = sellingPlanId;
      }

      if (sections) {
        cartData.sections = sections;
        cartData.sections_url = window.location.pathname;
      }

      return cartData;
    }

    async handleSuccess(variantId, data, discountCode) {
      let discountApplied = false;
      let freshSectionsData = null;

      if (discountCode && discountCode.trim()) {
        try {
          await fetch(`/discount/${discountCode}`, {
            method: 'GET',
          });
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.renderContents) {
            const sections = cartDrawer
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',');

            const sectionsResponse = await fetch(`${window.Shopify.routes.root}cart?section_id=${sections}`);
            const sectionsHtml = await sectionsResponse.text();
            const sectionsData = { sections: {} };
            sectionsData.sections[sections.split(',')[0]] = sectionsHtml;

            cartDrawer.renderContents(sectionsData);
            freshSectionsData = sectionsData;
            discountApplied = true;
          }
        } catch (error) {
          console.error('Error applying discount code:', error);
        }
      }

      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
        // The add.js response predates the discount, so its `sections` would repaint the
        // drawer with pre-discount totals. Publish the post-discount markup we just fetched.
        const publishedCartData = freshSectionsData ? { ...data, sections: freshSectionsData.sections } : data;

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-upsell-jl-jc',
          productVariantId: variantId,
          cartData: publishedCartData,
        });
      }

      if (!discountApplied) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.renderContents && data.sections) {
          cartDrawer.renderContents(data);
        }
      }
    }

    handleError(data) {
      console.error('Error adding to cart:', data);
      alert(data.description || data.message || 'Error adding product to cart');
    }

      setLoadingState(isLoading) {
        if (!this.button) return;

        if (isLoading) {
          this.button.classList.add('loading');
          this.button.disabled = true;
          if (this.iconSpan) this.iconSpan.style.visibility = 'hidden';
          if (this.textSpan) this.textSpan.style.visibility = 'hidden';
          if (this.spinner) this.spinner.classList.remove('hidden');
        } else {
          this.button.classList.remove('loading');
          this.button.disabled = false;
          if (this.iconSpan) this.iconSpan.style.visibility = 'visible';
          if (this.textSpan) this.textSpan.style.visibility = 'visible';
          if (this.spinner) this.spinner.classList.add('hidden');
        }
      }
  }

  customElements.define('upsell-add-to-cart-jl-jc', UpsellAddToCartJlJc);
}
